/// <reference path="../../../node_modules/@types/three/index.d.ts" />
module Eseebase {
    export interface IWebglScope extends ng.IScope {
        faces: TriangulatedFace[];
        color: string;
        center: Point3;
    }

    export class WebglDirective {
        public link: (scope: IWebglScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => void;
        public templateUrl = '/app/directives/status-icon.html';
        public scope = {
            faces: '=faces',
            color: '=color'
        };
        public restrict = 'A';
        public require: string;
        public replace: any;

        constructor() {
            //WebglDirective.prototype.replace = 'true';
            WebglDirective.prototype.link = (scope: IWebglScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => {
                var vm = this;
                var width = 600;
                var height = 400;
                var widthHalfX = width / 2;
                var widthHalfY = height / 2;
                var camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 10);
                var scene = new THREE.Scene();
                var angle = 0;
                //var texture = new THREE.TextureLoader().load('textures/crate.gif');

                var colors = ['rgb(255, 50, 50)', 'rgb(30, 250, 80)', 'rgb(0, 50, 120)', 'rgb(125, 125, 50)', 'rgb(200, 150, 100)', 'rgb(100, 255, 0)',
                    'rgb(125, 100, 125)', 'rgb(40, 40, 200)', 'rgb(100, 0, 100)', 'rgb(0, 255, 120)', 'rgb(120, 120, 0)', 'rgb(255, 255, 0)',
                    'rgb(0, 50, 200)', 'rgb(70, 200, 70)', 'rgb(200, 200, 50)', 'rgb(80, 200, 200)', 'rgb(30, 150, 30)', 'rgb(20, 20, 20)'];
                var levels = [];
                var renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
                renderer.setClearColor(0x000000, 0);
                renderer.setPixelRatio(window.devicePixelRatio);
                renderer.setSize(width, height);
                element.append(renderer.domElement);
                //var xAxes = new THREE.Vector3(1, 0, 0).clone().sub(new THREE.Vector3(0, 0, 0));
                //var yAxes = new THREE.Vector3(0, 1, 0).clone().sub(new THREE.Vector3(0, 0, 0));
                //var zAxes = new THREE.Vector3(0, 0, 1).clone().sub(new THREE.Vector3(0, 0, 0));
                //scene.add(new THREE.ArrowHelper(xAxes.normalize(), new THREE.Vector3(0, 0, 0), 1, 0xff0000));
                //scene.add(new THREE.ArrowHelper(yAxes.normalize(), new THREE.Vector3(0, 0, 0), 1, 0x00ff00));
                //scene.add(new THREE.ArrowHelper(zAxes.normalize(), new THREE.Vector3(0, 0, 0), 1, 0x0000ff));
                var helper = new THREE.GridHelper(10, 100, 0x303030, 0x303030);
                //scene.add(helper);
                var directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
                directionalLight.position.x = 1;
                directionalLight.position.y = 1;
                directionalLight.position.z = 1;
                directionalLight.castShadow = true;
                directionalLight.position.normalize();
                //scene.add(directionalLight);
                scope.$watch('faces', updateCanvas);

                var render = function () {
                    angle += Math.PI / 320;
                    requestAnimationFrame(render);
                    camera.position.x = 0.7 *Math.cos(angle);
                    camera.position.y = 0.4;
                    camera.position.z = 0.7 * Math.sin(angle);
                    camera.lookAt(0, 0, 0);
                    camera.updateProjectionMatrix();
                    renderer.render(scene, camera);
                }

                var mesh: THREE.Mesh;
                function updateCanvas() {
                    if (scope.faces == null) {
                        return;
                    }
                    //vm.normalize(scope.faces);
                    //angular.forEach(scope.faces, function (face) {
                    //    var geometry = new THREE.Geometry();
                    //    for (var i = 0; i < face.vertices.length; i++) {
                    //        var v = face.vertices[i];
                    //        geometry.vertices.push(new THREE.Vector3(v.x, v.z, v.y));
                    //        if ((i + 1) % 2 == 0) {
                    //            geometry.faces.push(new THREE.Face3(i - 1, i, i >= face.vertices.length - 2 ? 0 : i + 1));
                    //        }
                    //    }
                    //    var idx = levels.indexOf(face.levelId);
                    //    if (idx == -1) {
                    //        levels.push(face.levelId);
                    //        idx = levels.length - 1;
                    //        if (idx > levels.length - 1) {
                    //            idx = levels.length - 1;
                    //        }
                    //    }
                    //    var material = new THREE.MeshPhongMaterial({ color: new THREE.Color(colors[idx]), specular: 0x009900, shininess: 30, flatShading: true }/*{ map: texture }*/);
                    //    var mesh = new THREE.Mesh(geometry, material);
                    //    scene.add(mesh);
                    //});

                    angular.forEach(scope.faces, function (face) {
                        if (face == null || face.vertices == null || face.indices == null) {
                            return;
                        }
                        var geometry = new THREE.Geometry();
                        for (var i = 0; i < face.vertices.length; i++) {
                            var v = face.vertices[i];
                            geometry.vertices.push(new THREE.Vector3(v.x, v.z, v.y));

                        }

                        for (var i = 0; i <= face.indices.length - 3; i += 3) {
                            var idx = face.indices[i] + 1;
                            geometry.faces.push(new THREE.Face3(face.indices[i], face.indices[i + 1], face.indices[i + 2]));

                        }

                        var idx = levels.indexOf(face.housingNumber);
                        if (idx == -1) {
                            levels.push(face.housingNumber);
                            idx = levels.length - 1;
                            if (idx > levels.length - 1) {
                                idx = levels.length - 1;
                            }
                        }
                        var material = new THREE.MeshBasicMaterial({ color: new THREE.Color(/*colors[idx]*/ 'rgb(200, 200, 200)'), side: THREE.DoubleSide }/*{ map: texture }*/);
                        //if (mesh != null) {
                        //    scene.remove(mesh);
                        //}
                        mesh = new THREE.Mesh(geometry, material);
                        scene.add(mesh);
                    });

                    camera.aspect = window.innerWidth / window.innerHeight;
                }
                render();

                //
                //window.addEventListener('resize', onWindowResize, false);
            };
        }

        public normalize(faces: GeometryFace[]) {
            var minPoint = new Point3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            var maxPoint = new Point3(Number.MIN_VALUE, Number.MIN_VALUE, Number.MIN_VALUE);
            for (var f of faces) {
                for (var v of f.vertices) {
                    if (minPoint.x > v.x) {
                        minPoint.x = v.x
                    }
                    if (minPoint.y > v.y) {
                        minPoint.y = v.y
                    }
                    if (minPoint.z > v.z) {
                        minPoint.z = v.z
                    }

                    if (maxPoint.x < v.x) {
                        maxPoint.x = v.x
                    }
                    if (maxPoint.y < v.y) {
                        maxPoint.y = v.y
                    }
                    if (maxPoint.z < v.z) {
                        maxPoint.z = v.z
                    }
                }
            }
            var xLength = Math.abs(maxPoint.x - minPoint.x);
            var yLength = Math.abs(maxPoint.y - minPoint.y);
            var zLength = Math.abs(maxPoint.z - minPoint.z);
            var maxLength = Math.max(xLength, yLength, zLength);

            for (var f of faces) {
                for (var v of f.vertices) {
                    v.x = (v.x - minPoint.x) / maxLength - (xLength / maxLength) / 2;
                    v.y = (v.y - minPoint.y) / maxLength - (yLength / maxLength) / 2;
                    v.z = (v.z - minPoint.z) / maxLength;
                }
            }
            
        }

        public static Factory() {
            var directive = () => {
                return new WebglDirective();
            };

            directive['$inject'] = [];

            return directive;
        }
    }

    angular
        .module('eseebase')
        .directive('webgl', WebglDirective.Factory());
}